// extracted by mini-css-extract-plugin
module.exports = {"NavFooter":"NavFooter_NavFooter__2G9MX"};